<template>
    <v-select :items="sortedCountries"
              item-text="name"
              item-value="code"
              :label="label"
              :value="value"
              v-model="country"
              :required="required"
              :error-messages="errorMessages"
              @input="onInput()"
              @blur="onBlur()"
              return-object>
    </v-select>
</template>

<script>
    import countryList from './Country/data';

    export default {
        props: {
            value: {
                type: String,
                default: '',
            },
            label: {
                type: String
            },
            errorMessages: {
                type: Array
            },
            required: {
                type: Boolean
            },
            preferredCountries: {
                type: Array
            }
        },
        mounted() {
            this.country = this.value;
        },
        watch: {
            value: function (newValue) {
                this.country = newValue;
            }
        },
        data: () => ({
            country: ''
        }),
        computed: {
            sortedCountries() {
                // Sort the list countries: from preferred countries to all countries
                const preferredCountries = this.getCountries(
                    this.preferredCountries,
                ).map(country => ({ ...country, preferred: true }));
                return [...preferredCountries, ...countryList];
            },
        },
        methods: {
            getCountries(list = []) {
                return list.map(countryCode => this.findCountry(countryCode))
                    .filter(Boolean);
            },
            findCountry(iso = '') {
                return countryList.find(country => country.code === iso);
            },
            onInput() {
                this.$emit('input', this.country.code);
            },
            onBlur() {
                this.$emit('blur');
            },
        }
    }
</script>